import { render, staticRenderFns } from "./QKPageEdit.vue?vue&type=template&id=6256a976&scoped=true"
import script from "./QKPageEdit.vue?vue&type=script&lang=js"
export * from "./QKPageEdit.vue?vue&type=script&lang=js"
import style0 from "./QKPageEdit.vue?vue&type=style&index=0&id=6256a976&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6256a976",
  null
  
)

export default component.exports